import React from "react";
import PropTypes from "prop-types";

import { SubtitlesButton } from "./SubtitlesButton";
import {
  LeftButtonsWrapper,
  LiveText,
  LiveWrapper,
  RedDot
} from "../index.stitches";
import { Countdown } from "../Countdown";
import { getIsMiniPlayer } from "../utils";
import { useOrcaCommonContext } from "../../orca/contexts/OrcaCommonContext";
import { useVideoDataContext } from "../../orca/contexts/VideoDataContext";
import { hasBurnedCaptions } from "../../orca/utils";

export const LeftButtons = ({ isVertical, hasSubtitles, isLive }) => {
  const {
    initDuration,
    playerSize,
    playerState,
    isFullscreen,
    setShowSubtitles
  } = useOrcaCommonContext();
  const { videoData } = useVideoDataContext();

  const isMiniPlayer = getIsMiniPlayer(playerSize, isFullscreen, isVertical);
  const renderSubtitlesButton = !isMiniPlayer && !hasBurnedCaptions(videoData);

  return (
    <LeftButtonsWrapper>
      {isLive ? (
        <LiveDot isMiniPlayer={isMiniPlayer} />
      ) : (
        isMiniPlayer && <Countdown initDuration={initDuration} />
      )}
      {renderSubtitlesButton && (
        <SubtitlesButton
          {...{
            setShowSubtitles,
            playerState,
            hasSubtitles
          }}
        />
      )}
    </LeftButtonsWrapper>
  );
};

LeftButtons.propTypes = {
  /** boolean flag to denote if the video is vertical */
  isVertical: PropTypes.bool,
  /** Does the video have subtitles. */
  hasSubtitles: PropTypes.bool,
  isLive: PropTypes.bool
};

export const LiveDot = ({ isMiniPlayer }) => {
  return (
    <LiveWrapper>
      <RedDot />
      <LiveText
        css={{
          fontSize: isMiniPlayer ? "$087" : "$100"
        }}
      >
        LIVE
      </LiveText>
    </LiveWrapper>
  );
};

LiveDot.propTypes = {
  isMiniPlayer: PropTypes.bool
};
